var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0383 2.49988L0.907349 11.3863H18.8691L24 2.49988H6.0383Z",
    fill: "#F2962E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2237 12.6159C19.1941 12.6848 19.1467 12.7444 19.0863 12.7888C19.0259 12.8331 18.9548 12.8605 18.8803 12.868H2.44767L0.273315 16.5706H18.5158L23.7273 7.68201H22.1575L19.2237 12.6159Z",
    fill: "#F2962E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9499 17.7993C18.9204 17.8681 18.873 17.9277 18.8127 17.9721C18.7524 18.0164 18.6814 18.0438 18.6069 18.0514H2.17435L0 21.7536H18.2425L23.454 12.8672H21.8868L18.9499 17.7993Z",
    fill: "#F2962E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPdf);
export default __webpack_public_path__ + "static/media/edit-pdf.85ab4bc2286e48568122308bd339a61f.svg";
export { ForwardRef as ReactComponent };